import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import Loader from "../loader";
import { updateLeadStatus } from "../../actionCreator/leadListingActionCreater";
import KanbanView from "./KanbanView";
import { useAlert } from "../../context/AlertProvider";

const LeadKanbanView = ({
  calendarShow,
  loading,
  rowSelection,
  getDetails,
  executiveEmployeeList,
  paginationValue,
  companyFilterList,
  onPageChange,
}) => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [draggableLead, setDraggableLead] = useState({});
  const [leads, setLeads] = useState([]);
  const [showTagModal, setShowTagModal] = useState(false);
  const selectedRecords = useSelector(
    (state) => state.leadListingReducer.selectedRecords,
  );

  const updateLead = async (payload) => {
    const res = await dispatch(updateLeadStatus(payload));
    if (res?.response?.status === 403) {
      showAlert(
        "warning",
        "Permission Denied",
        "You do not have permission to update lead status.",
      );
      setLeads(leads?.length ? leads : executiveEmployeeList);
      return;
    }
    if (
      res.response &&
      res.response.status >= 400 &&
      res.response.status <= 500
    ) {
      showAlert("error", "Something went wrong. Please try again.");
    }
  };

  const onStatusUpdate = (obj) => {
    const newPayload = _.cloneDeep(
      leads?.length ? leads : executiveEmployeeList,
    );

    const updatedPayload = newPayload?.map((d) => {
      if (d.executiveData.statusId === draggableLead?.status) {
        return {
          ...d,
          executiveData: {
            ...d.executiveData,
            leadsList: d.executiveData?.leadsList?.filter(
              (i) => i.id !== obj.id,
            ),
          },
        };
      } else {
        if (d.executiveData.statusId === obj?.status) {
          return {
            ...d,
            executiveData: {
              ...d.executiveData,
              leadsList: [...d.executiveData?.leadsList, obj],
            },
          };
        } else {
          return d;
        }
      }
    });
    updateLead(obj);

    setLeads(updatedPayload);
  };

  const dropEvent = async (obj) => {
    const newPayload = _.cloneDeep(
      leads?.length ? leads : executiveEmployeeList,
    );
    newPayload.forEach(async (item) => {
      if (item.executiveData.statusId === draggableLead.status) {
        const filterList = item.executiveData.leadsList.filter(
          (it) => it.id !== draggableLead.id,
        );
        item.executiveData.totalRecords = filterList.length;
        item.executiveData.leadsList = filterList;
      }
      if (item.executiveData.statusId === obj.statusId) {
        let payload = _.cloneDeep(draggableLead);
        payload.status = obj.statusId;
        item.executiveData.leadsList.push(payload);
        item.executiveData.totalRecords = item.executiveData.leadsList.length;
        payload.customLayout = "1";
        updateLead(payload);
      }
      setLeads(newPayload);
    });
  };

  const dragStartEvent = (e, obj, obj1) => {
    setDraggableLead(obj);
  };

  return (
    <>
      {!loading ? (
        <div id="kanban">
          <KanbanView
            localExecutiveEmployeeList={
              leads?.length ? leads : executiveEmployeeList
            }
            dragStartEvent={dragStartEvent}
            dropEvent={dropEvent}
            draggableLead={draggableLead}
            updateLead={onStatusUpdate}
            showTagModal={showTagModal}
            setShowTagModal={setShowTagModal}
            selectedRecords={selectedRecords?.map((d) => d?.key)}
          />
        </div>
      ) : (
        <div id="kanban" className="container-fluid">
          <Loader />
        </div>
      )}
    </>
  );
};

export default LeadKanbanView;
